import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Rnd } from 'react-rnd';
import PartService from "../../Controller/PartController";
import DimensionService from "../../../Setup/controller/DimensionController/DimensionController";
import { handleSubmit } from "../../Controller/CreatePartDocumentController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import BASE_URL from "../../../../config/config";
import HelpSite from "../../../Common/HelpLink";
function PartImages({ StockID }) {
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    StockID = localStorage.getItem('StockID');
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    const PartID = StockID;
    const [formData, setFormData] = useState({
        PK_Stock_ID: PartID, FileName: '', Path: '', Name: 'Stock Image',
        Description: 'Stock Image', File: null, Width: 400, Height: 300 // Include Width and Height in formData
    });
    const [imagePreview, setImagePreview] = useState(null);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [DimensionList, setDimensionData] = useState([]);
    const [attachedImage, setAttachedImage] = useState('');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const fetchDimensionList = async () => {
        try {
            const listOfDimension = await DimensionService.GetAllDimensions(redirectCallback, PartID);
            setDimensionData(listOfDimension);
            debugger;
            const initialFormData = { ...formData };
            let hasAttachedImage = false; // Flag to check if an image is attached

            listOfDimension.forEach(dim => {
                // initialFormData[dim.PK_DimensionLabel_ID] = dim.vc_Value || '';
                if (dim.FileName) {
                    setAttachedImage(dim.FileName);
                    hasAttachedImage = true;
                }
            });

            // If an image is attached, set FileName in the form data
            if (hasAttachedImage) {
                initialFormData.FileName = listOfDimension[0].FileName; // Assuming you want to set FileName based on the first dimension
            }

            setFormData(initialFormData);
        } catch (error) {
            console.error('Error fetching dimensions:', error);
        }
    };

    const fetchPartImages = async () => {
        try {
            const data = await PartService.GetPartByID(redirectCallback, PartID);
            debugger;
            setFormData(prevState => ({ ...prevState, ...data }));
        } catch (error) {
            console.error('Error fetching part images:', error);
        }
    };

    useEffect(() => {

        //setDimensionData([]);
        if (PartID > 0) {
            fetchPartImages();
            fetchDimensionList();
        }
        else {
            setAttachedImage('');
            setFormData({
                PK_Stock_ID: PartID, FileName: '', Path: '', Name: 'Stock Image',
                Description: 'Stock Image', File: null, Width: 400, Height: 300 // Include Width and Height in formData
            });
        }
    }, [PartID]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFormData(prevState => ({
            ...prevState,
            File: file,
            Path: file ? file.name : '',
            Width: 400, // Reset width and height when a new file is selected
            Height: 300
        }));
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
                // Clear the attached image state
                setAttachedImage('');
            };
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
        }
    };

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent the default form submission behavior

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const updatedFormData = {
            ...formData,
            PK_Stock_ID: PartID,
            DocID: 0,
            Name: "Stock Image",
            Description: "Stock Image"
        };
        const message = await handleSubmit(event, updatedFormData, setFormData, setErrors);
        debugger;
        if (message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
        window.scrollTo(0, 0);
        fetchPartImages();
    };

    const clearFile = () => {
        setFormData(prevState => ({
            ...prevState,
            File: null,
            Path: '',
            Width: 250, // Reset width and height when file is cleared
            Height: 300
        }));
        setImagePreview(null);
    };
    const handleWidthChange = (event) => {
        const width = parseInt(event.target.value, 10) || 0;
        setFormData(prevState => ({
            ...prevState,
            Width: width
        }));
    };

    const handleHeightChange = (event) => {
        const height = parseInt(event.target.value, 10) || 0;
        setFormData(prevState => ({
            ...prevState,
            Height: height
        }));
    };

    const HelpLink = localStorage.getItem('HelpLink');
    const CompanyID = localStorage.getItem("CompanyID");

    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ height: "400px", overflow: "auto" }}>
                <div className="col-sm-12">
                    <form onSubmit={handleFormSubmit}>

                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr>

                                    <td style={{ width: "13%" }}>
                                        <label htmlFor="img_StockImage" style={{ float: "right" }}>Attach File &nbsp;&nbsp;</label>
                                    </td>
                                    <td style={{ width: "37%" }}>
                                        <input type="file" className="form-control file-control" name="File" onChange={handleFileChange} />
                                        {errors.File && <div style={{ color: 'red' }}>{errors.File}</div>}
                                    </td>
                                    <td style={{ width: "13%" }}></td>
                                    <td style={{ width: "37%" }}></td>
                                </tr>
                                <tr>
                                    <td>
                                        <label htmlFor="img_StockImage" style={{ float: "right" }}>Width &nbsp;&nbsp;</label>
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="Width" value={formData.Width} onChange={handleWidthChange} />
                                    </td>
                                    <td>
                                        <label htmlFor="img_StockImage" style={{ float: "right" }}>Height &nbsp;&nbsp;</label>
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="Height" value={formData.Height} onChange={handleHeightChange} />
                                    </td>
                                </tr>

                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{ float: "right" }}>
                                        <button type="submit" className={`btn btn-primary ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                           <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  Save
                                        </button>
                                        <button style={{ "marginLeft": "5px" }} type="button" className="btn btn-secondary" onClick={clearFile}>
                                            <i className="icofont-close" aria-hidden="true"> Clear</i>
                                        </button>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="row mb-3">
                            {attachedImage && (
                                <div className="col-sm-12">
                                    <label htmlFor="img_StockImage" style={{ float: "right" }}></label>
                                    <div className="col-sm-10">
                                        <img style={{
                                            width: `${DimensionList[0].Width}px`,
                                            height: `${DimensionList[0].Height}px`,
                                            maxWidth: '100%'
                                        }} src={`${BASE_URL}/uploads/${CompanyID}/Part/Document/${attachedImage}`} alt="Attached" />
                                    </div>
                                </div>
                            )}
                        </div>

                        {imagePreview && (
                            <div className="row mb-3" style={{ marginLeft: "10px" }}>
                                <label htmlFor="img_StockImage" style={{ float: "right" }}></label>
                                <div className="col-sm-10">
                                    <Rnd
                                        size={{ width: formData.Width, height: formData.Height }}
                                        onResizeStop={(e, direction, ref, d) => {
                                            setFormData(prevState => ({
                                                ...prevState,
                                                Width: prevState.Width + d.width,
                                                Height: prevState.Height + d.height
                                            }));
                                        }}
                                        disableDragging={true} // Add this line to disable dragging
                                    >
                                        <img src={imagePreview} alt="Preview" style={{ maxWidth: '100%' }} />
                                    </Rnd>
                                </div>
                            </div>
                        )}




                    </form>
                </div>
            </div>
        </div>
    );
}

export default PartImages;
